import MakerJS, { type exporter } from "makerjs";
import * as OpenType from "opentype.js";
// import { svgToDxf } from "SVGtoDXFApiClient";

import { Download, MimeType } from "./Download";
import { MakerJSModel } from "./MakerJSModel";

export const SCALE_SVG_FACTOR_FOR_DXF = 3.779535310528379;
enum FontFamily {
  NOTO = "NOTO",
}
const fontsToLoad: { [key in FontFamily]: string } = {
  [FontFamily.NOTO]: "/fonts/NotoMono-Regular.ttf",
};

const fonts: { [key in FontFamily]: OpenType.Font | null } = {
  [FontFamily.NOTO]: null,
};

for (const fontName of Object.keys(fontsToLoad) as FontFamily[]) {
  OpenType.load(fontsToLoad[fontName], (err, loadedFont) => {
    if (err) {
      console.error(err);
    } else if (loadedFont) {
      fonts[fontName] = loadedFont;
    }
  });
}

async function svgToDxf(_svgContent: string): Promise<string> {
  // const svgToDxf = require("svg-to-dxf");
  return "todo";
}

export class MakerJSDownload extends Download {
  protected model: MakerJSModel;

  constructor(
    title: string,
    mimeType: MimeType.SVG | MimeType.DXF,
    options?: {
      dxfRenderOptions?: exporter.IDXFRenderOptions;
      svgRenderOptions?: exporter.ISVGRenderOptions;
    },
  ) {
    super(title, mimeType);
    this.model = new MakerJSModel(options);
  }
  public async getContent(): Promise<string> {
    switch (this.mimeType) {
      case MimeType.DXF_VIA_SVG: {
        const svgContent = MakerJS.exporter.toSVG(this.model, {
          fontSize: "2",
          strokeWidth: "0.2",
          svgAttrs: { xmlns: "http://www.w3.org/2000/svg" },
          units: "mm",
        });
        return await svgToDxf(svgContent);
      }
      case MimeType.DXF: {
        return this.model.toDXF();
      }
      case MimeType.SVG: {
        return MakerJS.exporter.toSVG(this.model, {
          fontSize: "2",
          strokeWidth: "0.2",
        });
      }
      default: {
        throw new Error(`Unsupported mime type: ${this.mimeType}`);
      }
    }
  }
}
